import { render, staticRenderFns } from "./DnsAssociateVpcList.vue?vue&type=template&id=1dbf145c&"
import script from "./DnsAssociateVpcList.vue?vue&type=script&lang=js&"
export * from "./DnsAssociateVpcList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports